import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _toConsumableArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";

var _templateObject;

import styled from 'styled-components';
import { useEffect, useState, Fragment, useRef } from 'react';
import Image from 'next/legacy/image';
import useSWR from 'swr';
import useSWRInfinite from 'swr/infinite';
import { useTranslation } from '@yoweb/next-i18next';
import { getColor, getRadii, getSpace } from '@yoweb/ui/styles/utils/theme';
import { FlyoutTodoLayout } from '@poplar/components/Flyout/FlyoutTodo';
import { Box } from '@yoweb/ui/components/Box';
import { TodoCard, CustomTodoBanner } from './TodoCard';
import { Grid } from '@yoweb/ui/components/Grid';
import { Interactive, Text } from '@yoweb/ui/components/typography';
import { DragScroll } from '@yoweb/ui/components/DragScroll';
import { API_TASK_TEMPLATE_CATEGORY, API_TASK_TEMPLATE_SAMPLE_TODOS } from '@poplar/constants/routes';
import Spinner from '@yoweb/ui/components/Spinner';
import Search from './Search';
import { useUser } from '@poplar/hooks/useUser';
import { fetcher } from '@yoweb/utils/common';
import { useToast } from '@yoweb/ui/hooks/useToast';
import { Flex } from '@yoweb/ui/components/Flex';
import { FlyoutClose } from '@poplar/components/Flyout/FlyoutClose';
import { media } from '@yoweb/ui/styles/utils';
import { trackEvent } from '@yoweb/utils/analytics/mixpanel';
import { NO_CTA_ID } from '@yoweb/utils/constants/analyticEvents';
import { TodoEntryPoint, TodoType, Action } from '@yoweb/types/external-events';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CHUNK_SIZE = 18;
export var TodoDiscovery = function TodoDiscovery(_ref) {
  var onClose = _ref.onClose,
      onTemplateClicked = _ref.onTemplateClicked,
      onCreateCustomClicked = _ref.onCreateCustomClicked;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;

  var _useToast = useToast(),
      showToastError = _useToast.showToastError;

  var _useState = useState([]),
      selectedCategories = _useState[0],
      setSelectedCategories = _useState[1];

  var isSearchActiveRef = useRef(false);

  var _useSWR = useSWR(isAuthenticated ? API_TASK_TEMPLATE_CATEGORY : undefined, fetcher),
      categories = _useSWR.data,
      isCategoriesLoading = _useSWR.isLoading,
      categoriesError = _useSWR.error;

  var _useSWRInfinite = useSWRInfinite(function (index, prev) {
    var _prev$paginationDetai;

    var categoryIds = selectedCategories.map(function (category) {
      return category.id;
    });

    if (index === 0) {
      return API_TASK_TEMPLATE_SAMPLE_TODOS(categoryIds);
    }

    var paginationToken = (_prev$paginationDetai = prev.paginationDetailsFe) === null || _prev$paginationDetai === void 0 ? void 0 : _prev$paginationDetai.encodedNextPageToken;

    if (!paginationToken) {
      return null;
    }

    return API_TASK_TEMPLATE_SAMPLE_TODOS(categoryIds, paginationToken);
  }, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  }),
      sampleTodosPages = _useSWRInfinite.data,
      sampleTodosError = _useSWRInfinite.error,
      isSampleTodosLoading = _useSWRInfinite.isLoading,
      isSampleTodosValidating = _useSWRInfinite.isValidating,
      setSize = _useSWRInfinite.setSize,
      size = _useSWRInfinite.size;

  useEffect(function () {
    trackEvent({
      cta: {
        action: Action.ACTION_TODO_DISCOVERY_ENTERED,
        id: NO_CTA_ID
      }
    });
  }, []);
  useEffect(function () {
    if (sampleTodosError) {
      showToastError();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [sampleTodosError]);
  useEffect(function () {
    if (categoriesError) {
      showToastError();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [categoriesError]);
  var sampleTodos = sampleTodosPages === null || sampleTodosPages === void 0 ? void 0 : sampleTodosPages.flatMap(function (page) {
    return page.sampleTodoTilesList;
  });

  var fetchMore = function fetchMore() {
    return !(isSampleTodosLoading || isSampleTodosValidating) && setSize(size + 1);
  };

  var sampleTodoGroups = [];

  if (sampleTodos) {
    for (var i = 0; i < sampleTodos.length; i += CHUNK_SIZE) {
      sampleTodoGroups.push(sampleTodos.slice(i, i + CHUNK_SIZE));
    }
  }

  var handleCategoryClick = function handleCategoryClick(category) {
    var categoryIndex = selectedCategories.indexOf(category);
    var newSelectedCategories = categoryIndex === -1 ? [].concat(_toConsumableArray(selectedCategories), [category]) : selectedCategories.filter(function (cat) {
      return cat !== category;
    });
    setSelectedCategories(newSelectedCategories);
    trackEvent({
      todoDiscoveryFiltersUpdated: {
        categoryFiltersList: newSelectedCategories.map(function (c) {
          return c.name;
        })
      }
    });
  };

  var onCreateCustomClickedHandler = function onCreateCustomClickedHandler() {
    onCreateCustomClicked();
    trackEvent({
      todoStart: {
        title: '',
        entryPoint: TodoEntryPoint.TODO_ENTRY_POINT_TODO_DISCOVERY,
        type: TodoType.TODO_TYPE_C
      }
    });
  };

  return /*#__PURE__*/_jsxs(FlyoutTodoLayout, {
    title: t('todo-intake.top-level-title'),
    description: t('todo-intake.discovery-description'),
    descriptionSize: "bodyLg",
    backgroundColor: "base000",
    headerBackgroundColor: "base000",
    onScrollToBottom: fetchMore,
    closeButton: /*#__PURE__*/_jsx(FlyoutClose, {
      bgColor: "sand",
      iconSize: 20,
      onClose: function (_onClose) {
        function onClose() {
          return _onClose.apply(this, arguments);
        }

        onClose.toString = function () {
          return _onClose.toString();
        };

        return onClose;
      }(function () {
        onClose();

        if (isSearchActiveRef.current) {
          trackEvent({
            cta: {
              action: Action.ACTION_TODO_DISCOVERY_SEARCH_EXIT,
              id: NO_CTA_ID
            }
          });
        }
      })
    }),
    header: /*#__PURE__*/_jsx(Search, {
      isSearchActiveRef: isSearchActiveRef,
      onTemplateClicked: onTemplateClicked,
      onCreateCustomClicked: onCreateCustomClickedHandler
    }),
    children: [/*#__PURE__*/_jsx(DragScrollContainer, {
      children: isCategoriesLoading ? /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(Spinner, {})
      }) : /*#__PURE__*/_jsx(DragScroll, {
        children: /*#__PURE__*/_jsxs(Box, {
          display: "flex",
          flexDirection: "row",
          gap: "small3",
          px: "normal3",
          children: [categories && /*#__PURE__*/_jsx(TaskCategoryPill, {
            type: "button",
            isSelected: selectedCategories.length === 0,
            onClick: function onClick() {
              setSelectedCategories([]);
            },
            "data-testid": "categories-pill",
            children: /*#__PURE__*/_jsx(Box, {
              px: "small2",
              children: /*#__PURE__*/_jsx(Text, {
                size: "md",
                weight: "semibold",
                children: t('all')
              })
            })
          }), categories === null || categories === void 0 ? void 0 : categories.map(function (category, i) {
            return /*#__PURE__*/_jsxs(TaskCategoryPill // eslint-disable-next-line react/no-array-index-key
            , {
              type: "button",
              isSelected: selectedCategories.includes(category),
              onClick: function onClick() {
                return handleCategoryClick(category);
              },
              "data-testid": "categories-pill",
              children: [/*#__PURE__*/_jsx(Box, {
                height: 20,
                width: 20,
                children: /*#__PURE__*/_jsx(Image, {
                  src: category.iconImageUrl,
                  height: 20,
                  width: 20
                })
              }), /*#__PURE__*/_jsx(Interactive, {
                weight: "semibold",
                size: "md",
                children: category.name
              })]
            }, "template-category-".concat(i));
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Grid, {
      columns: "1fr 1fr",
      children: sampleTodoGroups === null || sampleTodoGroups === void 0 ? void 0 : sampleTodoGroups.map(function (group, i) {
        var oddTodos = group.filter(function (_, index) {
          return index % 2 !== 0;
        });
        var evenTodos = group.filter(function (_, index) {
          return index % 2 === 0;
        }); // Prevent the Type C banners from showing right next to each other at the end

        var hideFinalCustomBanner = i === sampleTodoGroups.length - 1 && sampleTodoGroups[i].length < 4;
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          _jsxs(Fragment, {
            children: [/*#__PURE__*/_jsx(Flex, {
              flexDirection: "column",
              gap: "normal1",
              children: evenTodos.map(function (sampleTodo, j) {
                return /*#__PURE__*/_jsx(TodoCard // eslint-disable-next-line react/no-array-index-key
                , {
                  onSelect: function onSelect(templateId, skipPdp) {
                    return onTemplateClicked(templateId, skipPdp);
                  },
                  sampleTodo: sampleTodo
                }, "sample-todo-even-".concat(i, "-").concat(j));
              })
            }), /*#__PURE__*/_jsx(Flex, {
              flexDirection: "column",
              gap: "normal1",
              children: oddTodos === null || oddTodos === void 0 ? void 0 : oddTodos.map(function (sampleTodo, j) {
                return /*#__PURE__*/_jsx(TodoCard // eslint-disable-next-line react/no-array-index-key
                , {
                  onSelect: function onSelect(templateId, skipPdp) {
                    return onTemplateClicked(templateId, skipPdp);
                  },
                  sampleTodo: sampleTodo
                }, "sample-todo-odd-".concat(i, "-").concat(j));
              })
            }), !hideFinalCustomBanner && /*#__PURE__*/_jsx(CustomTodoBannerContainer, {
              backgroundColor: "sandLight",
              radii: "small",
              p: "small4",
              children: /*#__PURE__*/_jsx(CustomTodoBanner, {
                title: t('todo-discovery.cant-find'),
                size: "sm",
                ctaText: t('todo-intake.create-type-c'),
                onClick: onCreateCustomClicked
              })
            })]
          }, "group-".concat(i))
        );
      })
    }), /*#__PURE__*/_jsx(Box, {
      display: "flex",
      justifyContent: "center",
      minHeight: 50,
      mt: "normal1",
      children: (isSampleTodosLoading || isSampleTodosValidating) && /*#__PURE__*/_jsx(Spinner, {
        "data-testid": "sample-todo-spinner"
      })
    })]
  });
};
var CustomTodoBannerContainer = styled(Box).withConfig({
  componentId: "sc-1v7xowj-0"
})(["&&{grid-column:span 2;}"]);
var TaskCategoryPill = styled.button.withConfig({
  componentId: "sc-1v7xowj-1"
})(["display:flex;align-items:center;border-radius:", ";cursor:pointer;border:1px solid ", ";background-color:", ";padding:", " ", ";gap:", ";white-space:nowrap;&:hover{border:1px solid ", ";}"], getRadii('large'), function (_ref2) {
  var isSelected = _ref2.isSelected;
  return isSelected ? getColor('gingko') : getColor('sandDark');
}, function (_ref3) {
  var isSelected = _ref3.isSelected;
  return isSelected ? getColor('gingko') : getColor('base000');
}, getSpace('small3'), getSpace('small4'), getSpace('small2'), getColor('stoneLight'));
var DragScrollContainer = styled.div.withConfig({
  componentId: "sc-1v7xowj-2"
})(["margin:", " -", " ", " -", ";", ""], getSpace('small1'), getSpace('normal2'), getSpace('normal3'), getSpace('normal2'), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: ", " -", " ", " -", ";\n  "])), getSpace('small1'), getSpace('normal3'), getSpace('normal3'), getSpace('normal3')));